import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  AppBar,
  Toolbar,
  Link,
  useTheme,
  Grid,
} from "@mui/material";
import { color, motion } from "framer-motion"; // Importamos Framer Motion
import PromotionsCarousel from "../components/PromotionsCarousel";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import Logo from "../images/Recurso.png";
import { useNavigate } from "react-router-dom";
import escuela1 from "../images/escuela1.jpg";
import hostal1 from "../images/fondohome.jpeg";
import hostal2 from "../images/hostal1.jpg";
import foto1 from "../images/foto1.jpg";
import foto2 from "../images/foto2.jpg";
import hostalmaps from "../images/hostalmaps.JPG";
import fotohostal1 from "../images/fotohostal1.jpg";
import fotohostal2 from "../images/fotohostal2.jpg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import mosaico1 from "../images/pattern01blanco.svg"; // Importa el SVG
import {
  Wifi,
  DirectionsCar,
  BeachAccess,
  LocalLaundryService,
  Bathroom,
  Hotel,
  Kitchen,
  LocalActivity,
  HotTub,
  Bed,
  LocationOn,
} from "@mui/icons-material";

const useStyles = {
  typography: {
    fontFamily: "'Billion Dreams', cursive", // Utilizamos la tipografía Billion Dreams
    fontWeight: "bold", // Opcional: si quieres que el texto sea negrita
    fontSize: "3rem", // Tamaño del texto
    fontStyle: "italic", // Esto hará que la tipografía sea cursiva
    color: "#fff",
  },
};
function HomePage() {
  const images = [
    `url(${hostalmaps})`,
    `url(${hostal2})`,
    `url(${fotohostal1})`,
    `url(${fotohostal2})`,
  ];
  // Configuración del carrusel
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 1000, // Velocidad del desplazamiento
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000, // 3 segundos entre desplazamientos
    responsive: [
      {
        breakpoint: 960, // Se activa en móviles y tablets
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const services = [
    {
      icon: <Wifi fontSize="large" />,
      label: "Wi-Fi",
    },
    {
      icon: <DirectionsCar fontSize="large" />,
      label: "Estacionamiento",
    },
    {
      icon: <BeachAccess fontSize="large" />,
      label: "Cerca de la Playa",
    },
    {
      icon: <LocalLaundryService fontSize="large" />,
      label: "Lavandería",
    },
    {
      icon: <Kitchen fontSize="large" />,
      label: "Cocina Equipada",
    },
    {
      icon: <Hotel fontSize="large" />,
      label: "Living",
    },
    {
      icon: <Bathroom fontSize="large" />,
      label: "3 Baños Compartidos",
    },
    {
      icon: <Bed fontSize="large" />,
      label: "Habitaciones Privadas",
    },
    {
      icon: <HotTub fontSize="large" />,
      label: "Agua Caliente",
    },
    {
      icon: <Bed fontSize="large" />,
      label: "Ropa de Cama",
    },
    {
      icon: <LocalActivity fontSize="large" />,
      label: "Beneficios Locales",
    },
    {
      icon: <LocationOn fontSize="large" />,
      label: "Ubicación Central",
    },
  ];

  const backgrounds = [
    `url(${hostal1})`,
    `url(${hostal2})`,
    `url(${foto1})`,
    `url(${foto2})`,
    `url(${fotohostal1})`,
    `url(${fotohostal2})`,
  ];

  // Estado para manejar el fondo actual
  const [currentBackground, setCurrentBackground] = useState(backgrounds[0]);
  const [currentText, setCurrentText] = useState(0);
  const [currentImage, setCurrentImage] = useState(images[0]);
  const theme = useTheme();
  const texts = [
    "Explora Pichilemu como un local",
    "Surf, gastronomía y paisajes únicos",
    "Descubre los mejores spots de Punta de Lobos",
    "Planes hechos a tu medida",
    "Tu próxima escapada comienza aquí",
    "Alojamientos cerca de las mejores olas",
    "Experiencias auténticas garantizadas",
    "Reserva hoy y vive algo único",
    "Déjate guiar por expertos en Pichilemu",
    "Escápate a lo extraordinario, ¡hoy!",
  ];

  // Cambiar imagen cada 5 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prevImage) => {
        const currentIndex = images.findIndex((img) => img === prevImage);
        const nextIndex = (currentIndex + 1) % images.length;
        return images[nextIndex];
      });
    }, 3000);

    return () => clearInterval(interval);
  }, []);
  const navigate = useNavigate();

  // Cambiar texto cada 3 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentText((prevText) => (prevText + 1) % texts.length);
    }, 3000); // Cambia cada 3 segundos

    return () => clearInterval(interval); // Limpiar intervalos al desmontar el componente
  }, []);
  // Cambiar el fondo dinámicamente cada 5 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBackground((prev) => {
        const currentIndex = backgrounds.indexOf(prev);
        const nextIndex = (currentIndex + 1) % backgrounds.length;
        return backgrounds[nextIndex];
      });
    }, 3000); // Cambia cada 5 segundos

    return () => clearInterval(interval); // Limpieza del intervalo
  }, []); // Asegura que se ejecute correctamente

  return (
    <Box>
      {/* Contenedor con scroll snapping */}
      <Box
        sx={{
          scrollSnapType: "y mandatory", // Snap al desplazarse
          overflowY: "scroll", // Scroll vertical
          height: "100vh",
        }}
      >
        {/* Animación de la barra de navegación */}
        <AppBar
          initial={{ opacity: 0, y: -100 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2 }}
          className="appbar"
          position="fixed"
          elevation={1}
          sx={{
            backgroundColor: "rgba(120, 200, 199, 0)", // Fondo semitransparente
            backdropFilter: "blur(10px)", // Desenfoque de 10px
            justifyContent: "center",
          }}
        >
          <Toolbar
            sx={{
              backgroundColor: "rgba(120, 200, 199, 0.11)", // Fondo semitransparente
              backdropFilter: "blur(10px)", // Desenfoque de 10px
              justifyContent: "space-between",
            }}
          >
            <Link
              to="/"
              style={{
                fontWeight: "bold",
                textDecoration: "none",
                color: "#556B2F",
                fontFamily: "'Playfair Display', Arial, sans-serif",
              }}
            >
              <Box>
                <img
                  src={Logo}
                  alt="Logo"
                  style={{
                    margin: "2vh",
                    width: "15vh",
                    height: "15vh",
                  }}
                />
              </Box>
            </Link>
            <Button
              variant="contained"
              onClick={() => navigate("/reserve")}
              sx={{
                fontSize: { xs: "1rem", xl: "1.5rem" },
                color: "#fff",
                backgroundColor: "#16A357",
                borderRadius: "5vh",
              }}
            >
              <Typography>Consultar Disponibilidad</Typography>
              <EventAvailableIcon sx={{ marginLeft: "0.5rem" }} />
            </Button>
          </Toolbar>
        </AppBar>

        {/* Sección 1: VISITA PICHILMU AWARNESS */}
        <Box
          component="section"
          sx={{
            scrollSnapAlign: "start",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundImage: currentBackground,
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
            transition: "background-image 1s ease-in-out",
            "::before": {
              content: '""',
              position: "absolute",
              width: "100%",
              height: "100%",
              background:
                "linear-gradient(to bottom, rgba(0, 0, 0, 0.12), rgba(0, 0, 0, 0.59))",
              zIndex: 1,
            },
          }}
        >
          {/* Contenedor de texto con fondo semi-transparente */}
          <Box
            sx={{
              position: "absolute",
              top: "35vh",
              textAlign: "center",
              backgroundColor: "rgba(255, 255, 255, 0)",
              padding: "20px 40px",
              borderRadius: "20px",
              boxShadow: "0px 0px 10px rgba(255, 255, 255, 0.09)",
              zIndex: 2,
            }}
          >
            <Typography
              component="span"
              sx={{
                fontSize: { xs: "2rem", sm: "3rem", md: "4rem" }, // Escalable
                fontWeight: 700, // Más grueso para destacar
                fontFamily: "Montserrat, sans-serif", // Usa la tipografía del theme
                letterSpacing: "1px", // Mejor separación entre letras
                lineHeight: 1.2, // Espaciado correcto
                color: "#FFF", // Contraste alto
                textShadow: "2px 2px 10px rgba(0, 0, 0, 0.8)", // Mejor visibilidad
                animation: "fade-in 1s ease-in-out",
                elevation: "0px",
              }}
            >
              {texts[currentText]}
            </Typography>
          </Box>
        </Box>
        {/* Sección 2: Hostal Bichon... */}
        <Box component="main">
          {/* 📌 PRIMERA SECCIÓN: PRESENTACIÓN DEL HOSTAL */}
          <Box
            component="section"
            sx={{
              scrollSnapAlign: "start",
              minHeight: "100vh",
              display: "flex",
              alignItems: "center",
              backgroundColor: "#556F7A",
              position: "relative",
              transition: "background-image 1s ease-in-out",
              "::before": {
                content: '""',
                position: "absolute",
                width: "100%",
                height: "100%",
                background:
                  "linear-gradient(to bottom, rgba(0, 0, 0, 0.12), rgba(0, 0, 0, 0.59))",
                zIndex: 1,
              },
            }}
          >
            <Grid
              container
              xs={12}
              sx={{
                position: "relative",
                zIndex: 2,
                maxWidth: "100vh",
                width: "100%",
                display: "flex",
                alignItems: "center",
                flexDirection: { xs: "column", md: "row" }, // Dos secciones separadas en xs, columnas en md
                justifyContent: "space-around",
              }}
            >
              <Grid
                item
                xs={12}
                md={4}
                xl={4}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: {
                      xs: "column",
                      sm: "column",
                      lg: "row",
                      xl: "row",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: {
                        xs: "column",
                        sm: "column",
                        lg: "column",
                        xl: "column",
                      },
                      padding: {
                        xs: "5vh",
                        sm: "column",
                      },
                    }}
                  >
                    <Typography
                      variant="h4"
                      sx={{
                        fontWeight: "bold",
                        color: "#FFF",
                        textShadow: "2px 2px 10px rgba(0,0,0,0.5)",
                        marginBottom: "20px",
                      }}
                    >
                      Bienvenido a Nuestro Hostal
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#EEE",
                        maxWidth: "500px",
                        lineHeight: "1.6",
                      }}
                    >
                      Nuestra casa, con más de 120 años de historia, ha sido un
                      refugio para viajeros y aventureros. Ubicada en el corazón
                      de Pichilemu, combina comodidad con una auténtica
                      experiencia costera. Descubre nuestras áreas comunes y
                      relájate con vistas inigualables.
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                {/* 📌 IMAGEN DINÁMICA DENTRO DE UN `Box` */}
                <Box
                  sx={{
                    display: { xs: "none", sm: "none", lg: "flex" },
                    backgroundImage: currentImage,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    width: "100%",
                    maxWidth: "100%",
                    height: "300px", // Altura ajustable
                    marginTop: "20px",
                    borderRadius: "10px",
                    boxShadow: "0px 5px 15px rgba(255,255,255,0.2)",
                    transition: "opacity 1s ease-in-out",
                  }}
                />
              </Grid>
            </Grid>
          </Box>

          {/* 📌 SEGUNDA SECCIÓN: SERVICIOS INCLUIDOS */}
          <Box
            component="section"
            sx={{
              scrollSnapAlign: "start",
              minHeight: "100vh",
              display: "flex",
              alignItems: "center",
              backgroundColor: "#556F7A",
              position: "relative",
              transition: "background-image 1s ease-in-out",
              "::before": {
                content: '""',
                position: "absolute",
                width: "100%",
                height: "100%",
                background:
                  "linear-gradient(to bottom, rgba(0, 0, 0, 0.12), rgba(0, 0, 0, 0.59))",
                zIndex: 1,
              },
            }}
          >
            <Grid
              container
              xs={12}
              sx={{
                scrollSnapAlign: "start",
                position: "relative",
                zIndex: 2,
                maxWidth: "100vh",
                width: "100%",
                display: "flex",
                alignItems: "center",
                flexDirection: { xs: "column", md: "row" }, // Dos secciones separadas en xs, columnas en md
                justifyContent: "space-around",
              }}
            >
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                {/* 📌 IMAGEN DINÁMICA DENTRO DE UN `Box` */}
                <Box
                  sx={{
                    display: { xs: "none", sm: "none", lg: "flex" },
                    backgroundImage: currentImage,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    width: "100%",
                    maxWidth: "100%",
                    height: "300px", // Altura ajustable
                    marginTop: "20px",
                    borderRadius: "10px",
                    boxShadow: "0px 5px 15px rgba(255,255,255,0.2)",
                    transition: "opacity 1s ease-in-out",
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                xl={4}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: { xs: "center", md: "left" },
                  overflow: "hidden", // Evita desplazamiento lateral
                }}
              >
                <Box
                  component="section"
                  sx={{
                    minHeight: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#445A64",
                    padding: "40px 20px",
                    overflow: "hidden", // Evita cualquier desbordamiento
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: "bold",
                      color: "#FFF",
                      textShadow: "2px 2px 10px rgba(0,0,0,0.5)",
                      marginBottom: "30px",
                      textAlign: "center",
                    }}
                  >
                    Servicios Incluidos
                  </Typography>

                  <Box
                    sx={{
                      width: "100%",
                      maxWidth: "600px",
                      overflow: "hidden",
                    }}
                  >
                    <Slider
                      {...sliderSettings}
                      style={{
                        maxWidth: "100%", // Asegura que no desborde
                      }}
                    >
                      {services.map((service, index) => (
                        <Box
                          key={index}
                          sx={{
                            textAlign: "center",
                            color: "#FFF",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 1,
                            backdropFilter: "blur(5px)",
                            borderRadius: "10px",
                            minHeight: "auto",
                            padding: "10px", // Asegura que no haya desbordamiento
                            boxSizing: "border-box",
                            "&:hover": {
                              transform: "scale(1.05)",
                              transition: "transform 0.3s ease-in-out",
                            },
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <Box>{service.icon}</Box>
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: "bold", fontSize: "1.5rem" }}
                            >
                              {service.label}
                            </Typography>
                          </Box>
                        </Box>
                      ))}
                    </Slider>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Box
          sx={{
            scrollSnapAlign: "start",
            height: "100vh",
            backgroundImage: `url(${escuela1})`, // Asegúrate de usar `url()`

            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          {/* Sección 2: Texto sobre la Escuela de Surf Lobos del Pacífico */}

          <PromotionsCarousel />
        </Box>

        {/* Sección 3: Servicios destacados */}
      </Box>
    </Box>
  );
}

export default HomePage;
